import * as React from 'react'
import { styled } from 'next-yak'

import { lightweight, standalone, SymbolProps } from '../spritesheetUtils'

const KKBB_ONLY_ID = 'kkbb-only-logo-icon'

type LogoProps = React.SVGAttributes<SVGElement>

export function KkbbOnlyLogoSymbol({ id = KKBB_ONLY_ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id}>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M5.434.93c1.294 0 2.459.553 3.28 1.437l-3.14 3.179L8.66 8.67a4.465 4.465 0 0 1-3.226 1.378c-2.487 0-4.503-2.041-4.503-4.559C.93 2.972 2.947.931 5.434.931Zm5.921 1.554a1.528 1.528 0 0 1 1.52 1.535 1.53 1.53 0 0 1-1.254 1.516 1.532 1.532 0 0 1 1.26 1.512 1.527 1.527 0 0 1-1.517 1.54c-.442 0-.84-.19-1.118-.494L7.716 5.54l2.595-2.634c.272-.26.64-.422 1.044-.422Z"
        clipRule="evenodd"
      />
    </symbol>
  )
}

const KkbbOnlyLogoStandaloneContent = standalone(KkbbOnlyLogoSymbol, KKBB_ONLY_ID)

export const KkbbOnlyLogo = styled(function KkbbOnlyLogoComponent(props: LogoProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="13" height="13">
      <KkbbOnlyLogoStandaloneContent />
    </svg>
  )
})``

export const KkbbOnlyLogoLightweight = styled(function KkbbOnlyLogoComponent(props: LogoProps) {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="13" height="13">
      {lightweight(KKBB_ONLY_ID)}
    </svg>
  )
})``
